import {ByteKit} from "../../toolkit";

const CR = '\r';
const LF = '\n';
const CRLF = `${CR}${LF}`;

/**
 * constants
 */
export const PsdkConst = {
  DEF_CHARSET: 'gbk',
  CR,
  LF,
  CRLF,
  QUOTE: '"',
  DEF_NEWLINE_BINARY: ByteKit.textToU8A(CRLF),
  DEF_AUTHORS: ['fewensa <osuni@protonmail.com>'],
  DEF_ENABLED_NEWLINE: true,
  DEF_WRITE_CHUNK_SIZE: 512,
  EMPTY_BYTES: new Uint8Array([]),
};
